import React from "react";
import { useProductsContext } from "./products.context";
import useQueryParams from "../../hooks/useQueryParams";
import SearchInputWithQueryState from "../../components/SearchInputWithQueryState";

const CategoriesSelectInput = () => {
  const { categories } = useProductsContext();
  const { params, addOrUpdateParams, removeParam } = useQueryParams();

  const onCategoryChange = (e) => {
    if (e.target.value === "") removeParam("category");
    else addOrUpdateParams({ category: e.target.value, page: 1 });
  };

  return (
    <select
      name="filter-material"
      id="filter-material"
      placeholder="Select a category"
      value={params.category || ""}
      className="filter"
      onChange={onCategoryChange}
    >
      {[{ id: "", name: "All Categories" }, ...categories].map((category) => {
        return (
          <option key={category.id} className="button btn-create-product mr-2 align-left" value={category.id}>
            {category.name}
          </option>
        );
      })}
    </select>
  );
};

const ProductFilter = () => {
  return (
    <div className="div-division product-filters filters">
      <div className="left-side-column">
        <label htmlFor="filter-material">Keywords</label>
        <SearchInputWithQueryState
          queryKey="search"
          addOrUpdateAdditionalParams={{ page: 1 }}
          placeholder="Enter Product Title, SAP Code"
          className="search-products"
        />
      </div>
      <div className="right-side-column">
        <label htmlFor="filter-material">Category</label>
        <CategoriesSelectInput />
      </div>
    </div>
  );
};

export default ProductFilter;
